import DownloadService from './DownloadService.js';

export default DownloadService;